import { SortOrderEnum } from "modules/collections/details/model/collection";
import { Select, SelectProps } from "modules/common/components/ui/Select";
import { cn } from "utils/utils";

interface OrderSelectProps
  extends Pick<SelectProps, "variant" | "color" | "size"> {
  currentOrder: SortOrderEnum;
  onChange: (order: SortOrderEnum) => void;
  className?: string;
}

export function OrderSelect({
  currentOrder,
  onChange,
  className,
  variant,
  color,
  size,
}: OrderSelectProps) {
  return (
    <Select
      name="order"
      layout="horizontal"
      options={[
        {
          value: SortOrderEnum.Ascending,
          label: "Asc",
        },
        {
          value: SortOrderEnum.Descending,
          label: "Desc",
        },
      ]}
      value={currentOrder}
      onChange={(value) => onChange(value as SortOrderEnum)}
      label="Order"
      className={cn(className)}
      variant={variant}
      color={color}
      size={size}
    />
  );
}
